import { CookieRow } from './Components';

type Data = {
  strictlyNecessary: CookieRow[];
  functional: CookieRow[];
  statistics: CookieRow[];
};

const data: Data = {
  strictlyNecessary: [
    {
      host: 'OneTrust.com',
      cookies: [
        'OptanonConsent (365 days)',
        'OptanonAlertBoxClosed (365 days)',
      ],
    },
    {
      host: 'volvocars.com',
      cookies: ['PIM-SESSION-ID (Session)'],
    },
  ],
  functional: [],
  statistics: [
    {
      host: 'volvocars.com',
      cookies: ['_ga (2 years)', '_ga_xxxxxxx (2 years)'],
    },
  ],
};

export default data;
